import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import TopChoice from "./Detail/TopChoice";
import Gallery from "./Detail/Gallery";
import '../../../../public/css/suplier.css';
import { do_action } from '../../actions';
import { setPageRedirect } from '../../actions/index'
import ModalSignIn from '../Modal/ModalSignIn';
import {validateEmail, validateRequire, require} from '../../utils/validate';
import { GoogleApiWrapper, InfoWindow, Marker, Map } from "google-maps-react";
import {
    BASE_URL_ADMIN
} from '../../data/config';
class SuplierDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            banner: '',
            loginNoneRedirect: true,
            logo: '',
            noExeclusive: false,
            name_category: '',
            name_category_parent: '',
            id: 0,
            excerpt: '',
            execlusivePhoto: '',
            topChoices: [],
            listGallery: [],
            address: '',
            activeMarker: {},
            selectedPlace: {},
            centerMap: {
                lat: 21.015130,
                lng: 105.810570
            },
            lat: 21.015130,
            lng: 105.810570,
            loading: true,
            error: {
                name: ''
            }
        }
    }

    // getGoogleMaps() {
    //     if (!this.googleMapsPromise) {
    //         this.googleMapsPromise = new Promise((resolve) => {
    //             window.resolveGoogleMapsPromise = () => {
    //                 resolve(google);
    //                 delete window.resolveGoogleMapsPromise;
    //             };
    //             const script = document.createElement("script");
    //             const API = 'AIzaSyBF_l22BF-uydJCo8KZ1moia6Ts-uQ7-oU';
    //             script.src = `https://maps.googleapis.com/maps/api/js?key=${API}&callback=resolveGoogleMapsPromise`;
    //             script.async = true;
    //             document.body.appendChild(script);
    //         });
    //     }
    //     return this.googleMapsPromise;
    // }
    componentWillMount() {
        this.initDetail();
        this.initRedirectWithLogin();
        // this.getGoogleMaps().then((google) => {
        //     const uluru = {lat: this.state.lat, lng: this.state.lng};
        //     const map = new google.maps.Map(document.getElementById('map'), {
        //         zoom: 14,
        //         center: uluru
        //     });
        //     const marker = new google.maps.Marker({
        //         position: uluru,
        //         map: map
        //     });
        // });
    }

    componentDidMount() {
        
        this.initJquery();
    }

    initJquery() {
        let self = this;
        let execlusive = self.state.noExeclusive;
        $(document).ready(function($) {
            $("body").delegate('.page-see-more .read-more', 'click', function () {
                if($('.page-see-more .description-lightbox').hasClass('show-less-hide')){
                    $(this).html('Show Less.. >>');
                }
                else{
                    $(this).html('Read More.. >>');
                }
                $(this).parent().find('.description-lightbox').toggleClass('show-less-hide');
                // $('.page-see-more .description-lightbox').toggleClass('show-less-hide');
            });
            $('body').delegate('#offer-popup', 'shown.bs.modal', function () {
                self.handleGetExeclusiveOffer();
            });
        });                
    }
    initRedirectWithLogin() {
        let { dispatch } = this.props;
        let urlRedirect = '/suplier/' + this.props.match.params.suplier_id;
        dispatch(setPageRedirect(urlRedirect));
    }
    initDetail() {
        let self = this;
        do_action('get_supplier_detail', {id: this.props.match.params.suplier_id})
            .then(response => {
                if (response.code == 'SUCCESS') {
                    self.setState({
                        name: response.data.name,
                        name_category: response.data.category.name,
                        name_category_parent: response.data.category.parent_name,
                        banner: response.data.banner,
                        logo: response.data.logo,
                        id: response.data._id,
                        excerpt: response.data.excerpt,
                        address: response.data.address_long,
                        lat: Number(response.data.address_lat),
                        lng: Number(response.data.address_lng),
                        centerMap: {
                            lat: Number(response.data.address_lat),
                            lng: Number(response.data.address_lng)
                        },
                        loading: false
                    });
                    self.setTopchoices(response.data._id);
                    self.ListGallery(response.data._id);
                    self.setExeclusivePhoto(response.data._id);
                }
            })
            .catch(err => console.log(err));
    }
    setExeclusivePhoto(supplier_id) {
        let self = this;
        do_action('get_execlusive_photo', { supplier :supplier_id})
            .then(response => {
                if (response.code == 'SUCCESS') {
                    var execlusivePhoto = response.data ? response.data.image : ''; 
                    // if (response.data != null) {
                    //     this.noExeclusive: true;
                    // }
                    let noExeclusive = (response.data != null) ? false : true;
                    self.setState({
                        execlusivePhoto: execlusivePhoto,
                        noExeclusive: noExeclusive
                    });
                }
            })
            .catch(err => console.log(err));
    }
    setTopchoices(supplier_id) {
        let self = this;
        do_action('get_topchoices', { supplier :supplier_id})
            .then(response => {
                if (response.code == 'SUCCESS') {
                    self.setState({
                        topChoices: response.data
                    });
                }
            })
            .catch(err => console.log(err));
    }
    ListGallery(supplier_id) {
        let self = this;
        do_action('get_list_gallery', { supplier :supplier_id })
            .then(response => {
                if (response.code == 'SUCCESS') {
                    self.setState({
                        listGallery: response.data,
                        length : response.data.length
                    });
                }
            })
            .catch(err => console.log(err));
    }
    handleGetExeclusiveOffer() {
        var params = {
            customer : this.props.customer ? this.props.customer._id : null,
            supplier : this.state.id
        };
        do_action('save_voucher', params)
            .then(response => {
               if (response.code != 'SUCCESS') return alert('Can not add voucher because this supplier has not yet uploaded the voucher.');
               // if (response.code == 'SUCCESS') return alert(response.message);
            })
            .catch(err => console.log(err));
    }
    validate(params) {
        let val = [];
        val.push({ key: "name", option: { empty: true } });
        val.push({ key: "email", option: { empty: true, isEmail: true } });
        val.push({ key: "phone", option: { empty: true , isFloat: true} });
        let { status, error } = require(params, val); 
        this.setState({ error });
        return status;
    }

    handleEnquiry(e) {
        e.preventDefault();
        var { name, email, phone } = this.state;
        var params = {
            name     : $('input[type=text][name=name]').val(),
            email    : $('input[type=email][name=email]').val(),
            phone    : $('input[type=text][name=phone]').val(),
            supplier : this.state.id
        };
        if (this.validate(params) == false) return false;

        do_action('save_enquiry', params)
            .then(response => {
                if (response.code != 'SUCCESS'){
                    return alert(response.message);
                }
                else{
                    return alert('Your message was successfully sent!');
                }
            })
            .catch(err => console.log(err));  
        $('input[type=text][name=name]').val('');
        $('input[type=email][name=email]').val('');
        $('input[type=text][name=phone]').val('');   
        $('#form-enquiry-supplier').modal('hide');    
    }
    handleAlert() {
        let $ = window.$;
        $('#modal-sign-in').modal({
            show: true,
            backdrop: 'static',
            keyboard: false
        });
        return;
    }
    alertExeclusive(){
        alert('Can not add voucher because this supplier has not yet uploaded the voucher.');
        return;
    }
    onMarkerClick = (props, marker, e) =>
        this.setState({
        selectedPlace: props,
        activeMarker: marker,
       
        showingInfoWindow: true
    });

    onMapClicked = (props) => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            })
        }
    };
    render() {
        let {location, customer, dispatch} = this.props;
        let imgBanner;
        let imgLogo;

        if (this.state.banner) {
            imgBanner = BASE_URL_ADMIN + this.state.banner;
        }else{
            imgBanner = '/images/NoPhoto.jpg';
        }

        if (this.state.logo) {
            imgLogo = BASE_URL_ADMIN + this.state.logo;
        }else{
            imgLogo = '/images/NoPhoto.jpg';
        }
        let execlusive = this.state.noExeclusive;
        let fullname = this.props.customer.first_name + " " + this.props.customer.last_name;
        return (

            <Fragment>
                <div id="suplier-detail" className="suplier-detail">
                    <div className="banner" style={{ backgroundImage: "url("+ imgBanner +")" }}>
                        <div className="container">
                            <div className="info">
                                <div className="logo-suplier">
                                    <img src={imgLogo} alt="Ruhu Supplier"/>
                                </div>
                                <div className="info-detail">
                                    <h1 className="name">{this.state.name}</h1>
                                    <div className="cate">
                                        {(this.state.name_category_parent != null) ?(
                                            <span>{this.state.name_category_parent}</span>
                                        ) : null
                                        }
                                        <span>{this.state.name_category}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content content-supplier-detail">
                        <div className="container ">
                            <div className="row">
                                <div className="col-md-7">
                                    <div className="desciption">
                                        {this.state.excerpt}
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className="info">
                                        <div className="button">
                                            {(this.props.customer._id != null) ? (
                                                <button type="button" className="btn-button" data-toggle="modal" data-target="#form-enquiry-supplier"><img src={'/images/supplier-enquiry.png'} alt="Ruhu"/>ENQUIRY</button>
                                            ) : 
                                                
                                                <button type="button" className="btn-button" data-toggle="modal" data-target="#alert-popup" data-backdrop="static" data-keyboard="false"><img src={'/images/supplier-enquiry.png'} alt="Ruhu"/>ENQUIRY</button>
                                            }
                                        </div>
                                        <div className="button">
                                            {(this.props.customer._id != null) ? (
                                                (this.state.noExeclusive != true) ? (
                                                    <button type="button" className="btn-button" data-toggle="modal" data-target="#offer-popup"><img src={'/images/supplier-sale.jpg'} alt="Ruhu"/> Get Execlusive Offer</button>
                                                    ):

                                                    <button type="button" className="btn-button" onClick={this.alertExeclusive.bind(this)}><img src={'/images/supplier-sale.jpg'} alt="Ruhu"/> Get Execlusive Offer</button>
                                                
                                                ) : 
                                                <button type="button" className="btn-button" data-toggle="modal" data-target="#alert-popup" data-backdrop="static" data-keyboard="false"><img src={'/images/supplier-sale.jpg'} alt="Ruhu"/> Get Execlusive Offer</button>
                                            }
                                        </div>
                                        <div className="address">Address : {this.state.address}</div>
                                        { (this.state.loading == false) ? (
                                            <div className="map" id="map">
                                                <Map 
                                                    google={this.props.google} 
                                                    onClick={this.onMapClicked}
                                                    initialCenter={ this.state.centerMap }
                                                >
                                                <Marker onClick={this.onMarkerClick} name={this.state.address} />
                                                <InfoWindow marker={this.state.activeMarker} visible={this.state.showingInfoWindow}>
                                                    <div>
                                                      {/*<h1>{this.state.selectedPlace.name}</h1>*/}
                                                    </div>
                                                    </InfoWindow>
                                                </Map>
                                            </div>
                                        ) : null }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <TopChoice topChoices={ this.state.topChoices }/>
                    <Gallery listGallery={ this.state.listGallery }/>

                    <div id="form-enquiry-supplier" className=" form-enquiry modal fade" role="dialog">
                        <div className="modal-dialog modal-dialog-enquiry" role="document">
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                            <div className="background-top"></div>
                            <div className="form-enquiry-inline">
                                <div className="input-form-enquiry">
                                    <i className="fa fa-user"></i>
                                    <input type="text" className="form-control" name='name' placeholder="NAME" defaultValue={fullname}/>
                                </div>
                                <div className="error">{ this.state.error.name }</div>
                                <div className="input-form-enquiry">
                                    <i className="fa fa-envelope"></i>
                                    <input type="email" className="form-control" name='email' placeholder="EMAIL" defaultValue={this.props.customer.email} />
                                </div>
                                <div className="error">{ this.state.error.email }</div>
                                <div className="input-form-enquiry">
                                    <i className="fa fa-phone"></i>
                                    <input type="text" className="form-control" name='phone' placeholder="TEL" defaultValue={this.props.customer.phone} />
                                </div>
                                <div className="error">{ this.state.error.phone }</div>
                                <button className="btn-enquiry" onClick={ this.handleEnquiry.bind(this)}>SUBMIT</button>
                                <div className="alert-info hidden">success</div>
                            </div>
                        </div>
                    </div>

                    <div id="offer-popup" className="offer-popup modal fade" role="dialog">
                        <div className="modal-dialog modal-dialog-offer" role="document">
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                            <div className="offer-inline">
                                <div className="offer col-offer">
                                    <h3>Congratulation</h3>
                                    <div className="img-offer">
                                        <img src={ BASE_URL_ADMIN + this.state.execlusivePhoto } alt="Ruhu" />
                                    </div>
                                </div>
                                <div className="logo col-offer">
                                    <img src={imgLogo} alt="Ruhu" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="alert-popup" className="alert-popup modal fade" role="dialog" >
                        <div className="modal-dialog modal-dialog-alert" role="document">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <h4>Please login to continue.</h4>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.handleAlert.bind(this)}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/*<ModalSignIn dispatch={dispatch} />*/}
                </div>
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    const { customer } = state;
    return {
        customer
    }
}

// export default connect(mapStateToProps)(SuplierDetail);
export default connect(mapStateToProps)(GoogleApiWrapper({
  apiKey: "AIzaSyBF_l22BF-uydJCo8KZ1moia6Ts-uQ7-oU"
})(SuplierDetail))